module.exports = __webpack_public_path__ + "media/images/family-signup-b3d161d116c06d2f89645f277617447e.jpg";